export default __webpack_public_path__ + "static/media/reward_img.aa67df9e.png";